import { render } from "./RouterAdmin.vue?vue&type=template&id=3ee02d84&scoped=true"
import script from "./RouterAdmin.vue?vue&type=script&lang=js"
export * from "./RouterAdmin.vue?vue&type=script&lang=js"

import "./RouterAdmin.vue?vue&type=style&index=0&id=3ee02d84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee02d84"]])

export default __exports__